export class User {
  static COL: string = 'users';
  loginType?: 'google' | 'email';
  createdAt?: Date = new Date();
  lang?: string; // 2 chars
  roomSettings?: RoomSetting[] = [];
  notificationSettings?: RoomNotificationSetting[] = []; // Deprecated
  isBot?: boolean = false;

  // 워크스페이스 소유 관련 (Phase 0: 무료 워크스페이스 제한)
  ownedWorkspaceIds?: string[] = [];       // 소유한 워크스페이스 ID 목록
  hasPaidContract?: boolean = false;       // 유료 계약 경험 여부 (한 번이라도)
  maxFreeWorkspaces?: number = 1;          // 무료 워크스페이스 생성 한도 (기본 1개)

  // 최근 접속 (하루에 한 번 업데이트)
  lastActiveAt?: Date;

  constructor(public id: string, public name: string, public email: string, public photoUrl: string | null, public description: string) {
  }

  static empty(): User {
    return new User("", "", "", "", "");
  }
}

//users/userfmctokens
export class UserFCMToken {
  static COL: string = 'userfmctokens'; // fmc is misspelled but just leave it.
  public id: string;
  public token: string; // 실제 FCM 토큰 값 (슬래시 포함 가능)
  constructor(public userId: string, token: string, public updated: Date, public platform: 'android' | 'ios' | 'web' = 'web') {
    this.id = token;
    this.token = token;
  }
}

//users/appletokens
export class AppleToken {
  static COL: string = 'appletokens';
  public id: string;

  constructor(public userId: string, public refreshToken: string, public updated: Date) {
    this.id = userId;
  }

}

export class UserSimplified {
  id: string = "";
  name: string = "";
  email: string = "";
  photoUrl?: string | null = "";
}

/**
 * Convert User to UserSimplified
 */
export function toUserSimplified(user: User | UserSimplified): UserSimplified {
  return {
    id: user.id,
    name: user.name,
    email: user.email,
    photoUrl: user.photoUrl ?? null,
  };
}

/**
 * 메시지 저장용 최소 사용자 정보
 * User 전체 대신 이 인터페이스만 저장하여 저장소 절약
 */
export interface MessageUser {
  id: string;
  name: string;
  photoUrl?: string | null;
}

/**
 * User를 MessageUser로 변환
 */
export function toMessageUser(user: User | MessageUser): MessageUser {
  return {
    id: user.id,
    name: user.name,
    photoUrl: user.photoUrl ?? null,
  };
}

export class Uid {
  static get(): string {
    //uuidv4
    return 'xxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      // eslint-disable-next-line
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
}

export class RoomSetting {
  favoriteRoomInMyList: boolean = false;
  hideRoomInMyList: boolean = false;
  disablePushNotifications: boolean = false;
  allowMentionPushNotifications: boolean = false;
  disableVoiceCallPopups: boolean = false;
  disableEmailReminders: boolean = false;

  constructor(public roomId: string) {
  }
}

export class RoomNotificationSetting {
  constructor(public roomId: string, public option: NotificationOption) {
  }
}

export type NotificationOption = 'default' | 'disable-push-notification';
